import React from "react"
import { PageContext } from "../layout/Page"


export const OnlyLangs = ({ children, langs = [] }) => <PageContext.Consumer>
  {page => langs.includes(page.lang) && children}
</PageContext.Consumer>

export const OnlyCountries = ({ children, countries = [] }) => <PageContext.Consumer>
  {page => countries.includes(page.country) && children}
</PageContext.Consumer>

export const OnlyFolders = ({ children, folders = [] }) => <PageContext.Consumer>
  {page => folders.includes(page.folder) && children}
</PageContext.Consumer>

export const AllFoldersExcept = ({ children, folders = [] }) => <PageContext.Consumer>
  {page => !folders.includes(page.folder) && children}
</PageContext.Consumer>

export const OnlyEnglish = ({ children }) => <OnlyLangs langs={["en"]}>{children}</OnlyLangs>
export const OnlyItalian = ({ children }) => <OnlyLangs langs={["it"]}>{children}</OnlyLangs>
export const OnlySpanish = ({ children }) => <OnlyLangs langs={["es"]}>{children}</OnlyLangs>
export const OnlyFrench = ({ children }) => <OnlyLangs langs={["fr"]}>{children}</OnlyLangs>

export const OnlyUk = ({ children }) => <OnlyCountries countries={["gb"]}>{children}</OnlyCountries>
export const OnlyItaly = ({ children }) => <OnlyCountries countries={["it"]}>{children}</OnlyCountries>
export const OnlySpain = ({ children }) => <OnlyCountries countries={["es"]}>{children}</OnlyCountries>
export const OnlyFrance = ({ children }) => <OnlyCountries countries={["fr"]}>{children}</OnlyCountries>